/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { forwardRef } from 'react';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

import { Field } from 'formik';

export const RenderCheckbox = forwardRef(function RenderCheckbox(props, ref) {
  const {
    field,
    // form: { touched, errors },
    label,
    ...others
  } = props;
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={field.value}
          value={field.name}
          name={field.name}
          onChange={field.onChange}
          color="primary"
          ref={ref}
        />
      }
      label={label}
      {...others}
    />
  );
});
export const FormCheckbox = ({ name, ...others }) => (
  <Field name={name} component={RenderCheckbox} {...others} />
);
